// extracted by mini-css-extract-plugin
export default {"content":"style_content__5Pout","itemName":"style_itemName__MquJ2"};